import type { QagentHomeDict } from '../en/qagentHome';

export const qagentHome: QagentHomeDict = {
  header: {
    resources: 'Resurser',
    recentChats: 'Senaste chattar',
  },
  greeting: {
    welcome: (firstName: string) => `Välkommen, ${firstName}`,
    fallback: 'Hej där',
    subtitle: 'Vilka juridiska ärenden tar vi oss an idag?',
  },
  prompts: {
    firstDraft: {
      label: 'Första utkast',
      tooltip: 'Skapa ett nytt avtal eller juridiskt dokument från grunden',
    },
    reviewContract: {
      label: 'Granska ett avtal',
      prompt: 'Granska detta dokument för potentiella problem och risker',
    },
    checkCompliance: {
      label: 'Kontrollera efterlevnad',
      prompt: 'Kontrollera detta dokument för GDPR-efterlevnadsproblem',
    },
    suggestImprovements: {
      label: 'Föreslå förbättringar',
      prompt:
        'Föreslå förbättringar för att stärka det juridiska språket i detta dokument',
    },
    askQuestion: {
      label: 'Ställ en fråga',
      prompt: 'Vilka är de viktigaste villkoren och skyldigheterna i detta dokument?',
    },
  },
  input: {
    placeholder: 'Meddela QAgent...',
    addProjectContext: 'Lägg till projektkontext',
    noProjectsYet: 'Inga projekt än',
    fileCount: (count: number) => `${count} fil${count !== 1 ? 'er' : ''}`,
    hasChat: ' · har chatt',
  },
  dropZone: {
    attachToProject: (projectName: string) =>
      `Släpp för att bifoga till ${projectName}`,
    attachToProjectFallback: 'Släpp för att bifoga till projekt',
    startNewProject: 'Släpp för att starta ett nytt projekt med denna fil',
  },
  uploadDialog: {
    title: 'Laddar upp fil...',
    percentComplete: (percent: number) => `${percent}% klart`,
  },
  linkPlaybookDialog: {
    title: 'Länka Playbook',
    description: 'Välj en playbook att länka till detta projekt.',
    playbookLabel: 'Playbook',
    selectPlaceholder: 'Välj en playbook',
    noAvailablePlaybooks: 'Inga tillgängliga playbooks',
    linking: 'Länkar...',
    submit: 'Länka Playbook',
  },
  deleteFileDialog: {
    title: 'Ta bort fil',
    description: (name: string) =>
      `Är du säker på att du vill ta bort "${name}"? Denna åtgärd kan inte ångras.`,
    deleting: 'Tar bort...',
  },
  unlinkPlaybookDialog: {
    title: 'Avlänka Playbook',
    description: (name: string) =>
      `Är du säker på att du vill avlänka "${name}" från detta projekt?`,
    unlinking: 'Avlänkar...',
    confirm: 'Avlänka',
  },
  toasts: {
    createProjectFailed: 'Kunde inte skapa projekt',
    uploadFileFailed: 'Kunde inte ladda upp fil',
    fileAttached: (name: string) => `${name} bifogad`,
    fileUploadedSuccess: (name: string) => `Filen "${name}" laddades upp`,
    uploadError: 'Fel vid uppladdning av fil',
    playbookLinkedSuccess: 'Playbook länkad',
    linkPlaybookFailed: 'Kunde inte länka playbook',
    linkError: 'Fel vid länkning av playbook',
    fileDeleted: (name: string) => `Filen "${name}" borttagen`,
    deleteFileFailed: 'Kunde inte ta bort fil',
    deleteError: 'Fel vid borttagning av fil',
    playbookUnlinked: (name: string) => `Playbook "${name}" avlänkad`,
    unlinkPlaybookFailed: 'Kunde inte avlänka playbook',
    unlinkError: 'Fel vid avlänkning av playbook',
    startContractFailed: 'Kunde inte starta avtal',
  },
  generateDialog: {
    title: 'Skapa ett nytt dokument',
    description:
      'Berätta för QAgent vad som ska skapas. Du kan förfina det efter att det genererats.',
    docTypeLabel: 'Dokumenttyp',
    docTypePlaceholder: 't.ex. NDA, Anställningsavtal, Tjänsteavtal',
    descriptionLabel: 'Beskrivning',
    descriptionOptional: '(valfritt)',
    descriptionPlaceholder:
      'Viktiga krav, villkor, jurisdiktion, särskilda klausuler...',
    playbookLabel: 'Playbook',
    noPlaybook: 'Ingen playbook',
    playbookMeta: (agreementType: string, ruleCount: number) =>
      `${agreementType} • ${ruleCount} ${ruleCount === 1 ? 'regel' : 'regler'}`,
    starting: 'Startar...',
    submit: 'Börja skriva utkast',
    docTypeSuggestions: {
      nda: 'NDA',
      employmentAgreement: 'Anställningsavtal',
      serviceContract: 'Tjänsteavtal',
      consultingAgreement: 'Konsultavtal',
    },
  },
  chatHistory: {
    title: 'Chatthistorik',
    description: 'Dina senaste konversationer med QAgent',
    loading: 'Laddar...',
    noConversations: 'Inga konversationer än',
    startFromHome: 'Starta en ny chatt från startskärmen',
    untitledChat: 'Ny chatt',
    messageCount: (count: number) => `${count} meddelande${count !== 1 ? 'n' : ''}`,
    deleteChat: 'Ta bort chatt',
  },
};
